import { Component, HostListener, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { KycService } from '@app/core/kyc.service';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { routerTransition } from '@app/router.animations';

import * as coverageFunc from '@app/features/coverage/coverage';

import { QuestionService } from '@app/core/question.service';
import { QuestionControlService } from '@app/core/question-control.service';
import { NewPolicyComponent } from '@app/features/coverage/new-policy/new-policy.component';
import { NavTabService } from '@app/core/navTab.service';
import { MODAL_NEW_POLICY, MODAL_POLICY_DETAILS } from '@app/features/coverage/constants';
import { AddedPolicyDataModel } from './model';

declare var $;

@Component({
  selector: 'app-coverage',
  templateUrl: './coverage.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class CoverageComponent implements OnInit, OnDestroy {
  @ViewChild(NewPolicyComponent) newPolicy: NewPolicyComponent;
  @ViewChild('insurancesWrapper') insurancesWrapper: ElementRef;

  // Modal
  selectedModal = MODAL_NEW_POLICY;
  newPolicyData = {};
  addedPolicyData = new AddedPolicyDataModel();
  gender = 1; // male
  iconPosition = '0%';

  // Functions
  convertKeysToLabels: any;
  convertKeyToValue: any;
  getOptionsFromQuestionRaws: any;
  getInsuranceBasedOnKey: any;
  getPropertyNames: any;
  getTypeOfQuestion: any;
  formatStringToCurrency: any;

  // Constants
  productsSortedToDisplay = [
    { keyInsurance: 'PAInsurances', key: 'personalAccident', text: 'Personal Accident', actived: false },
    { keyInsurance: 'lifeInsurances', key: 'termLife', text: 'Term Life', actived: false },
    { keyInsurance: 'healthInsurances', key: 'criticalIllness', text: 'Critical Illness', actived: false },
    { keyInsurance: 'assetInsurances', key: 'assetInsurances', text: 'Asset Protection', subText: '(Motor, Property...)', actived: false },
    { keyInsurance: 'lifeInsurances', key: 'incomeProtection', text: 'Income Protection', actived: false },
    { keyInsurance: 'lifeInsurances', key: 'longTermCare', text: 'LongTerm Care', actived: false },
    { keyInsurance: 'healthInsurances', key: 'health', text: 'Health', actived: false }
  ];
  itemAges: number[] = [18, 25, 35, 45, 55, 65, 75, 85];
  insurancesSortedToDisplay = [
    { key: 'healthInsurances', text: 'Health Insurances', actived: false },
    { key: 'lifeInsurances', text: 'Life Insurances', actived: false },
    { key: 'assetInsurances', text: 'Asset Insurances', actived: false },
    { key: 'PAInsurances', text: 'PA Insurances', actived: false }
  ];

  // Variables
  insurances = [];
  showScrollToTop = false;
  chosenInsurance = '';

  constructor(
    private kycService: KycService,
    private router: Router,
    private questionService: QuestionService,
    private qcs: QuestionControlService,
    private navTabService: NavTabService
  ) {
    this.getPropertyNames = Object.keys;
  }

  scroll = (e) => {
    const currentScrollPos = e.target.scrollTop;
    this.showScrollToTop = false;
    if (
      currentScrollPos > 250
    ) {
      this.showScrollToTop = true;
    }
  }

  ngOnInit() {
    this.convertKeysToLabels = coverageFunc.convertKeysToLabels;
    this.convertKeyToValue = coverageFunc.convertKeyToValue;
    this.getOptionsFromQuestionRaws = coverageFunc.getOptionsFromQuestionRaws;
    this.getInsuranceBasedOnKey = coverageFunc.getInsuranceBasedOnKey;
    this.getTypeOfQuestion = coverageFunc.getTypeOfQuestion;
    this.formatStringToCurrency = coverageFunc.formatStringToCurrency;

    this.insurances = coverageFunc.getSortedInsurancesBasedOnKeys(
      this.kycService.kyc.coverage.insurances,
      this.insurancesSortedToDisplay
    );
    this.newPolicyData = coverageFunc.renderNewPolicyData(
      this.kycService.kyc.coverage.insurances[0],
      this.questionService,
      this.qcs
    );
    this.gender = Number(this.kycService.kyc.profile.userProfile.gender);
    this.iconPosition = coverageFunc.renderIconPosition(
      this.kycService.kyc.profile.userProfile.age
    );
    this.kycService.kyc.coverage.insurances.forEach(insurance => {
      if (insurance.actived) {
        this.insurancesSortedToDisplay.forEach(_insurance => {
          if (insurance.key === _insurance.key) {
            _insurance.actived = insurance.actived;
          }
        });
        this.productsSortedToDisplay.forEach(product => {
          if (insurance.key === product.keyInsurance) {
            if (product.key !== 'assetInsurances') {
              product.actived = insurance.products.find(_product => product.key === _product.key).actived;
            } else {
              product.actived = insurance.actived;
            }
          }
        });
      }
    });
    window.addEventListener('scroll', this.scroll, true);
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
  }

  setInsuranceActive(_product: { keyInsurance: string, key: string, text: string, actived: boolean }) {
    const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
    const currentScrollPos = document.getElementById('custom-scrollbar');
    if (isMobile) {
      currentScrollPos.scrollTo({
        top: $(this.insurancesWrapper.nativeElement).position().top + currentScrollPos.offsetWidth * 0.11,
        behavior: 'smooth'
      });
    } else {
      currentScrollPos.scrollTo({
        top: $(this.insurancesWrapper.nativeElement).position().top + 70,
        behavior: 'smooth'
      });
    }

    let numberOfActivedProduct = 0;
    this.productsSortedToDisplay.filter(product => {
      if (product.keyInsurance === _product.keyInsurance) {
        if (product.key === _product.key) {
          product.actived = !_product.actived;
          if (product.keyInsurance !== 'assetInsurances') {
            this.kycService.kyc.coverage.insurances.find(item => item.key === _product.keyInsurance)
              .products.find(item => item.key === _product.key).actived = product.actived;
          }
        }
        if (product.actived) {
          numberOfActivedProduct++;
        }
      }

    });
    this.insurancesSortedToDisplay.filter(insurance => {
      if (insurance.key === _product.keyInsurance) {
        if (numberOfActivedProduct === 0) {
          insurance.actived = false;
          this.kycService.kyc.coverage.insurances.find(item => item.key === _product.keyInsurance).actived = false;
        } else {
          insurance.actived = true;
          this.kycService.kyc.coverage.insurances.find(item => item.key === _product.keyInsurance).actived = true;
        }
      }
    });
  }

  getInsuranceStatus(insuranceKey: string) {
    let isActived = false;

    this.insurancesSortedToDisplay.filter(insurance => {
      if (insurance.key === insuranceKey && insurance.actived) {
        isActived = true;
      } else if (insurance.key === insuranceKey && !insurance.actived) {
        isActived = false;
      }
    });

    return isActived;
  }

  goToNextPage() {
    this.kycService.kyc.coverage.completed = true;
    this.router.navigateByUrl('/journey/my-needs');
    this.navTabService.setActiveTab('needs');
  }

  goToTop() {
    const currentScrollPos = document.getElementById('custom-scrollbar');
    currentScrollPos.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onAddNewPolicy(insuranceKey) {
    const chosenInsurance = coverageFunc.getInsuranceBasedOnKey(
      this.kycService.kyc.coverage.insurances,
      insuranceKey
    );
    this.newPolicyData = coverageFunc.renderNewPolicyData(
      chosenInsurance,
      this.questionService,
      this.qcs
    );
    this.selectedModal = MODAL_NEW_POLICY;
    $(`#${this.selectedModal}`).modal('show');
  }

  onViewDetails(insuranceKey, indexOfChosenPolicy) {
    this.chosenInsurance = insuranceKey;
    const chosenInsurance = coverageFunc.getInsuranceBasedOnKey(this.kycService.kyc.coverage.insurances, insuranceKey);
    this.addedPolicyData = coverageFunc.renderAddedPolicyData(chosenInsurance, indexOfChosenPolicy);

    if (this.addedPolicyData.policy['typeOfAsset']) {
      const filterOptions = coverageFunc.getOptionsFromQuestionRaws(this.addedPolicyData.questionRaws).filter(obj =>
        obj.key === this.addedPolicyData.policy['typeOfAsset']
      );

      this.addedPolicyData.policy = coverageFunc.filterPropertiesOfPolicyDetails(
        this.addedPolicyData.questionRaws,
        this.addedPolicyData.policy,
        filterOptions[0]
      );
    }

    this.selectedModal = MODAL_POLICY_DETAILS;
    $(`#${this.selectedModal}`).modal('show');
  }

  closeModal() {
    if (this.newPolicy) {
      this.newPolicy.isShownMoreDetails = false;
    }

    $(`#${this.selectedModal}`).modal('hide');
    this.goToTop();
  }

  addOtherPolicy() {
    if (this.newPolicy) {
      this.newPolicy.isShownMoreDetails = false;
    }

    this.onAddNewPolicy(this.chosenInsurance);
  }

  handleChildSubmit(data) {
    this.kycService.kyc.coverage.insurances.forEach(insurance => {
      if (insurance.key === data.insuranceKey) {
        const newPolicy = data.form.value;

        if (newPolicy.typeOfAsset) {
          insurance.productCategory.forEach(productCategory => {
            if (productCategory.productKey === newPolicy.typeOfAsset) {
              newPolicy.productCategory = productCategory.value;
              return;
            }
          });
        } else {
          newPolicy.productCategory = insurance.productCategory[0].value;
        }

        if (!newPolicy.productCategory) {
          newPolicy.productCategory = '';
        }

        insurance.questionRaws.forEach(question => {
          if (question.type && question.type === 'number') {
            newPolicy[question.key] = Number(newPolicy[question.key]);
          }
        });

        insurance.policies.push(newPolicy);

        return;
      }
    });
    $(`#${this.selectedModal}`).modal('hide');
  }

  handleChildRemove(data) {
    this.kycService.kyc.coverage.insurances.forEach(insurance => {
      if (insurance.key === data.key) {
        insurance.policies.splice(data.indexOfChosenPolicy, 1);
      }
    });

    $(`#${this.selectedModal}`).modal('hide');
    this.goToTop();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/coverage/coverage.component.ts